import { render, staticRenderFns } from "./FieldsList.vue?vue&type=template&id=29c29a1b&scoped=true&"
import script from "./FieldsList.vue?vue&type=script&lang=js&"
export * from "./FieldsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c29a1b",
  null
  
)

export default component.exports